import { createActions, createReducer } from 'reduxsauce';

// ==================
// Initial State
// ==================
export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: [],
  error: null,

  // store an array of category IDs selected elsewhere
  preSelected: [],
};

// ==================
// Action Types & Creators
// ==================
const { Types, Creators } = createActions(
  {
    reset: [],

    getCategoryList: [],
    getCategoryListRequest: [],
    getCategoryListSuccess: ['data'],
    getCategoryListFailure: ['error'],

    setPreselectedCategories: ['categoryIds'],
  },
  { prefix: 'cb/category/' },
);

export { Types as types, Creators as actions };

// ==================
// Reducer Functions
// ==================
const request = (state) => ({
  ...state,
  fetching: true,
  error: null,
});

const success = (state, { data }) => ({
  ...state,
  fetching: false,
  fetched: true,
  data,
  error: null,
});

const failure = (state, { error }) => ({
  ...state,
  fetching: false,
  fetched: false,
  error,
});

const setPreselectedCategories = (state, { categoryIds }) => ({
  ...state,
  preSelected: categoryIds,
});

// ==================
// Reducer Mapping
// ==================
const HANDLERS = {
  [Types.GET_CATEGORY_LIST_REQUEST]: request,
  [Types.GET_CATEGORY_LIST_SUCCESS]: success,
  [Types.GET_CATEGORY_LIST_FAILURE]: failure,
  [Types.SET_PRESELECTED_CATEGORIES]: setPreselectedCategories,
};

// ==================
// Reducer
// ==================
export default createReducer(INITIAL_STATE, HANDLERS);
